import Link from "next/link";
import React from "react";

export default function ItemGrid(props) {
  const {
    title, items, render, href, t
  } = props

  return (
    <>
      <div className="flex items-center mb-4">
        <h3 className="font-semibold grow text-lg">
          {title}
        </h3>
        {
          href ?
            <Link href={href}>
              <a>{
                  !!t ?
                      t('home:button_showall'):
                      'Show all'
              }</a>
            </Link> : null
        }
      </div>
      <div className="grid grid-cols-[repeat(auto-fill,minmax(250px,1fr))] gap-3">
        {
          items.map((item) => (
            render(item)
          ))
        }
      </div>
    </>
  )
}
